
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 .5c-4.413 0-8 3.587-8 8s3.587 8 8 8 8-3.587 8-8-3.587-8-8-8zm.693 7.333c.367 0 .667.3.667.667 0 .367-.3.667-.667.667H6.46a2.596 2.596 0 002.5 1.926c.367 0 .667.3.667.667 0 .367-.3.667-.667.667a3.932 3.932 0 01-3.867-3.26H4.66a.669.669 0 01-.667-.667c0-.367.3-.667.667-.667h.433a3.932 3.932 0 013.867-3.26c.367 0 .667.3.667.667 0 .367-.3.667-.667.667-1.2 0-2.207.82-2.5 1.926h2.233z","fill":"#F9A91E"}})])
          )
        }
      }
    